import React from 'react';
import { Button, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface Props {
	title: string;
	titleExtra?: React.ReactNode;
	subtitle?: string;
	showBack?: boolean;
	backPath?: string;
	defaultBackPath?: string;
	extra?: React.ReactNode;
	children: React.ReactNode;
}

const { Title } = Typography;

const BasePageLayout: React.FC<Props> = ({
	title,
	titleExtra,
	subtitle,
	showBack = false,
	backPath,
	defaultBackPath,
	extra,
	children,
}) => {
	const navigate = useNavigate();

	const handleBack = () => {
		// If explicit backPath provided → use it
		if (backPath) {
			navigate(backPath);
			return;
		}

		// If browser has history → go back
		if (window.history.length > 1) {
			navigate(-1);
			return;
		}

		// If no history (opened directly or from external)
		navigate(defaultBackPath ?? '/');
	};

	return (
		<div style={{ padding: 24 }}>
			<div style={{ marginBottom: 24 }}>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
						{showBack && (
							<Button icon={<ArrowLeftOutlined />} onClick={handleBack} />
						)}

						<div>
							<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
								<Title style={{ margin: 0 }}>{title}</Title>
								{titleExtra}
							</div>
							{subtitle && <div style={{ color: '#888' }}>{subtitle}</div>}
						</div>
					</div>

					{extra}
				</div>
			</div>

			{children}
		</div>
	);
};

export default BasePageLayout;
